// ─── Image Lightbox ──────────────────────────────────────────────────────────
export function Lightbox({ src, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center p-4" onClick={onClose}>
      <button onClick={onClose}
        className="absolute right-4 text-white text-4xl font-light hover:text-gray-300 transition-colors"
        style={{ top: 'calc(1rem + env(safe-area-inset-top, 0px))' }}>×</button>
      <img src={src} alt="Step reference" className="max-w-full max-h-full object-contain rounded-lg shadow-2xl" onClick={e => e.stopPropagation()} />
    </div>
  );
}
